export const en = {
    "details": "Details",
    "hide": "Hide news"
} as const;
export const ru = {
    "details": "Подробнее",
    "hide": "Скрыть эту новость"
} as const;